import React, { memo } from "react";
import { Stack, Typography, Card, CardContent, IconButton, Icon, Divider } from "investira.react.components";
const AtivoImovel = memo(props => {
  const {
    data
  } = props;
  //imovel,
  // area: 105000,
  // unidades: 2,
  // vacancia: 15,
  // inadimplencia: 3.5,
  // percentualDaReceita: 4.5,
  // percentualLocado: 85,
  // totalInvestidoDoFII: 70000000,
  // endereco: "Rua Doutor Júlio de Abreu, 300 - Eldorado, Sete Lagoas - MG",
  // caracteristicas: "Complexo industrial",

  return <Stack flexGrow={1}>
      <Card>
        <CardContent sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}>
          <Stack spacing={2}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{
            pb: 1
          }}>
              <Stack>
                <Typography variant="title" component="div" sx={{
                fontWeight: 600
              }}>
                  {data.imovel}
                </Typography>
              </Stack>

              <Stack>
                <IconButton variant={"contained"} color="primary" edge="end">
                  <Icon iconName="location" size={14} />
                </IconButton>
              </Stack>
            </Stack>
          </Stack>
          <Divider sx={{
          mx: -2
        }} />
          <Stack sx={{
          py: 2,
          gap: 1
        }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={4}>
              <Typography variant="caption" component="div">
                Área
              </Typography>
              <Typography variant="caption" component="div" sx={{
              fontWeight: 600
            }}>
                {data.area}
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={4}>
              <Typography variant="caption" component="div">
                Unidades
              </Typography>
              <Typography variant="caption" component="div" sx={{
              fontWeight: 600
            }}>
                {data.unidades}
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={4}>
              <Typography variant="caption" component="div">
                Vacância
              </Typography>
              <Typography variant="caption" component="div" sx={{
              fontWeight: 600
            }}>
                {data.vacancia}
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={4}>
              <Typography variant="caption" component="div">
                Inadimplência
              </Typography>
              <Typography variant="caption" component="div" sx={{
              fontWeight: 600
            }}>
                {data.inadimplencia}
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={4}>
              <Typography variant="caption" component="div">
                Percentual da Receita
              </Typography>
              <Typography variant="caption" component="div" sx={{
              fontWeight: 600
            }}>
                {data.percentualDaReceita}
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={4}>
              <Typography variant="caption" component="div">
                Percentual locado
              </Typography>
              <Typography variant="caption" component="div" sx={{
              fontWeight: 600
            }}>
                {data.percentualLocado}
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={4}>
              <Typography variant="caption" component="div">
                Total Investido do FII
              </Typography>
              <Typography variant="caption" component="div" sx={{
              fontWeight: 600
            }}>
                {data.totalInvestidoDoFII}
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" spacing={4}>
              <Typography variant="caption" component="div">
                Endereço
              </Typography>
              <Typography variant="caption" align="right" component="div" sx={{
              fontWeight: 600
            }}>
                {data.endereco}
              </Typography>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Stack>;
});
AtivoImovel.propTypes = {};
export default AtivoImovel;
